
import {finalize} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DossierService } from './dossier.service';
import { NotifierService, DialogService } from '../ui';
import { SLEntity } from '../shares-ledger/entity/entity';
import { SLEntitySearchDialogComponent } from '../shares-ledger/entity/entity-search-dialog.component';

@Component({
  templateUrl: './dossier-import.component.html',
})
export class DossierImportComponent implements OnInit {

  entity: SLEntity

  title: string

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dossierService: DossierService,
    private notifier: NotifierService,
    private dialogService: DialogService,
  ) { }

  ngOnInit() {
    this.title = this.route.routeConfig.data.title;
  }

  save() {
    if (!this.entity) {
      return;
    }

    let notifier = this.notifier;

    notifier.updateProgress(20);

    function onComplete() {
      notifier.endProgress();
    }

    
    this.dossierService
      .createSLEntity({
        sl_entity_id: this.entity.id,
        sl_entity_version: this.entity.version,
      }).pipe(
      finalize(onComplete))
      .subscribe((dossier) => {
        this.notifier.success('Dossier créé avec succès');

        // Got to edit screen
        this.router.navigate(['dossiers', dossier.id]);
      });
  }

  cancel() {
    this.router.navigateByUrl('/dossiers');
  }

  lookupEntity(event: Event) {
    this.dialogService.show({
      component: SLEntitySearchDialogComponent,
      props: {

        type: 'COMPANY',

        onClose: () => {
          this.dialogService.hide();
        },

        onSelect: (entity: SLEntity) => {
          this.dialogService.hide();

          this.entity = entity;
        }
      }
    });

    event.preventDefault();
  }
}
